import { produce } from 'immer';
import {
  DOWNLOAD_SEGMENT,
  GET_ALL_SEGMENT_TRACKER,
  PROCESS_UPLOADED_FILE,
  REMOVE_UPLOADED_FILE,
  SET_SEGMENT_OPERATION,
  SET_SEGMENT_DATA,
  UPDATE_SEGMENT_API_STATUS,
} from '../actions/createSegmentActionTypes';
import { CREATE_SEGMENT_FROM_FILE } from '../actions/nudgeActionTypes';

const intialState = {
  createSegmentWithFile: {
    content: '',
    fileName: '',
    fileSize: '',
    isUploaded: false,
    status: '',
  },
  segmentList: {
    status: '',
    data: [],
  },
  createSegmentResponse: {
    status: '',
    segmentId: '',
    message: '',
  },
  downloadSegment: {
    status: '',
    response: '',
  },
  segmentData: {
    segmentName: '',
    segmentDescription: '',
  },
  editMode: null,
  updateSegmentStatus: null,
};
export default function createSegment(state = intialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case PROCESS_UPLOADED_FILE: {
        draftState.createSegmentWithFile = action.payload ?? {};
        break;
      }
      case REMOVE_UPLOADED_FILE: {
        draftState.createSegmentWithFile = action.payload ?? {};
        break;
      }
      case GET_ALL_SEGMENT_TRACKER: {
        draftState.segmentList = action.payload ?? {};
      }
      case CREATE_SEGMENT_FROM_FILE: {
        draftState.createSegmentResponse = action.payload;
      }
      case DOWNLOAD_SEGMENT: {
        draftState.downloadSegment = action.payload;
        break;
      }
      case SET_SEGMENT_OPERATION: {
        draftState.editMode = action.payload;
        break;
      }
      case SET_SEGMENT_DATA: {
        draftState.segmentData = { ...draftState.segmentData, ...action.payload };
        break;
      }
      case UPDATE_SEGMENT_API_STATUS: {
        draftState.updateSegmentStatus = action.payload;
        break;
      }
      default: {
        break;
      }
    }
  });
}
